export default __webpack_public_path__ + "static/media/recruit_table_icon_3.47002243.svg";